import axios from 'axios';
import { getSessionCookie, setSessionCookie } from '../helpers/cookies';
const api = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
})

const tenantId = window.location.host.split(':')[0].split('.')[0];

const request = async (endpoint, obj, method, contentType) => {

    const promise = new Promise((resolve, reject) => {

        const session = getSessionCookie();

        if (session) {
            const now = new Date();
            const expiration = new Date(session.expiredToken);
            if (expiration < now) {
                setSessionCookie(null);
                window.location.reload();
                resolve(null);
            }
        }

        const success = (result => {
            var newResult = {
                status: result.status,
                message: result.message,
                data: result.data
            }

            resolve(newResult);
        });

        const failed = (error => {
            if (error.response) {
                if (error.response.status === 401 || error.response.status === 403)
                    reject({ status: error.response.status, message: "Sua sessão expirou. Realize o acesso novamente" });
                else
                    try {
                        reject({ status: error.response.data.status, message: error.response.data ? error.response.data.message : error.response.message });
                    }
                    catch {
                        reject({ status: 500, message: "Erro ao conectar com API" });
                    }
            }
            else {
                reject({ status: 500, message: "Erro ao conectar com API" });
            }
        })

        const headers = () => {
            const _headers = {
                headers: {
                    'Content-Type': contentType,
                    'tenantId': tenantId,
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                }
            };


            if (session) {
                _headers.headers.Authorization = `Bearer ${session.token}`
                _headers.headers["UserId"] = session.id;
                _headers.headers["Secretaria"] = session.secretaria_Id;
            }

            return _headers;
        }

        try {
            if (method == "POST")
                return api.post(endpoint, JSON.stringify(obj), headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method == "PUT")
                return api.put(endpoint, JSON.stringify(obj), headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method == "GET")
                return api.get(endpoint, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));
            else if (method == "DELETE")
                return api.delete(endpoint, headers())
                    .then(result => success(result))
                    .catch(error => failed(error));

        }
        catch (error) {
            var result = {
                status: 500,
                message: "Erro no servidor (500)"
            }
            reject(result);
        }
    });

    return promise;
};

const api_POST = async (endpoint, obj, contentType) => {
    let _contentType = contentType;
    if (!contentType)
        _contentType = 'application/json';
    return request(endpoint, obj, "POST", _contentType);
};

const api_PUT = async (endpoint, obj) => {
    return request(endpoint, obj, "PUT", 'application/json');
};

const api_DELETE = async (endpoint, obj) => {
    return request(endpoint, obj, "DELETE", 'application/json');
};

const api_GET = async (endpoint) => {
    return request(endpoint, null, "GET", 'application/json');
};

const api_GET_External = (endpoint) => {

    const promise = new Promise((resolve, reject) => {

        try {
            return axios.get(endpoint)
                .then(result => {
                    let newResult = {
                        status: result.status,
                        data: result.data,
                        headers: result.headers
                    }
                    resolve(newResult);
                })
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.status === 401 || error.response.status === 403) {
                            reject({ status: error.response.status, message: "Sua sessão expirou. Realize o acesso novamente" });
                        }
                        else {
                            try {
                                reject({ status: error.response.data.status, message: error.response.data ? error.response.data.message : error.response.message });
                            }
                            catch {
                                reject({ status: 500, message: "Erro ao conectar com API" });
                            }
                        }
                    }
                    else {
                        reject({ status: 500, message: "Erro ao conectar com API" });
                    }
                });

        } catch (error) {
            let result = {
                status: 500,
                message: "Erro no servidor."
            }
            reject(result);
        }

    });

    return promise;

};

export { api_POST, api_PUT, api_DELETE, api_GET, api_GET_External };